import { useContext, useEffect, useState } from 'react'

import ContextChoose from '../ContextChoose'
import { CustomWarning } from '../../../componentsNew/CustomWarning'
import { useAction, useSaveUserOpti } from '../../../api/actions/action'
import ManagerToken from '../../../classes/ManagerToken'
import { URL } from '../../../api/services/axios'
import { conditional, useAdicionarArtigoBaseOpti, useSelectPosts } from './customHooks'
import { alert } from '../../../componentsNew/CustomWarning/types'
import HeaderTable from '../../../componentsNew/Table/HeaderTable'
import Modal from '../../../componentsNew/Modal'
import ItemTable from '../../../componentsNew/Table/ItemTable'
import { SearchPorPalavraChave } from '../../Dashboard/Components/SearchPorPalavraChave'
import Checkbox from '../../../componentsNew/Checkbox'
import { ButtonAdicionar } from './ButtonAdicionar'
import { IoIosArrowForward } from 'react-icons/io'
import ContextSearch from '@pages/Dashboard/ContextSearch'

function CustomNoRowsOverlay() {
    return (
        <tr className="flex items-center justify-center h-full"> <td>Sem posts publicados </td></tr>
    )
}

const filtros = [
    { value: 'keyword', label: 'palavra-chave' },
    { value: 'title', label: 'título do artigo' },
]

export function DataGridChoose({ dataUserOpti }) {
    const { rows, rowsSelected, setRowsSelected, rowsSelectedSave, setRowsSelectedSave } = useContext(ContextChoose)

    const { selectPosts } = useSelectPosts()
    const { savePostBaseOpti, isSuccess, isError } = useAdicionarArtigoBaseOpti()
    const { mutateAsync: saveUserOpti, isSuccess: isSuccessSaveUserOpti } = useSaveUserOpti()

    const [selectedPosts, setSelectedPosts] = useState([])
    const [selectedPostsList, setSelectedPostsList] = useState(0)
    const [continuar, setContinuar] = useState(false)
    const [selectedAllPostsNotExist, setSelectedAllPostsNotExist] = useState(false)
    const [selectedPostsNotExist, setSelectedPostsNotExist] = useState(false)
    const [countPostsNotExist, setCountPostsNotExist] = useState(0)
    const [filteredRows, setFilteredRows] = useState([])
    const [countPostsSaved, setCountPostsSaved] = useState(0)
    const [isLoadingSavePosts, setIsLoadingSavePosts] = useState(false)
    const [finallySelection, setFinallySelection] = useState(false)
    const [isGratuito, setIsGratuito] = useState(false)
    const [redirecionarAnalytics, setRedirecionarAnalytics] = useState(false)

    const { mutate: getUserOpti, data: userOpti } = useAction()
    const { dataPlanoUsuario } = useContext(ContextSearch)

    useEffect(() => {
        if (dataUserOpti) {
            let gratuito = false;
            if (dataUserOpti?.data) {
                gratuito = dataUserOpti?.data?.perfis.includes(5)
                setIsGratuito(gratuito)
            }
            if (dataUserOpti?.status == 201) {
                saveUserOpti({
                    action: 'save_user_opti',
                    idUsuarioWordpress: dataUserOpti.data.usuarioWordpress?.id ?? 0,
                    idUsuarioOpti: dataUserOpti.data.usuarioWordpress?.idUsuario ?? 0,
                    login: dataUserOpti.data.login,
                    password: dataUserOpti.data.senha
                })
            }

            const arrayPosts = []
            const notExistPost = [];

            if (dataUserOpti?.data?.listaIdArtigosSelecionados.length > 0 && rows.length > 0) {

                setSelectedPostsList(dataUserOpti?.data?.listaIdArtigosSelecionados.length)
                let artigos = gratuito ? dataUserOpti?.data?.listaIdArtigosSelecionados : rows.map(a => a.id)
                artigos.forEach(item => {
                    const filteredPosts = rows?.filter(x => x.id === item)
                    if (filteredPosts?.length === 0) {
                        notExistPost.push(item)
                    }
                    else {
                        for (let i = 0; i < filteredPosts?.length; i++) {
                            arrayPosts.push(filteredPosts[i])
                        }
                    }
                })
                if (notExistPost.length === dataPlanoUsuario?.data?.quantidadeArtigos) setSelectedAllPostsNotExist(true)
                else if (notExistPost.length > 0) setSelectedPostsNotExist(true)
                setCountPostsNotExist(notExistPost.length)
                setRowsSelected(arrayPosts.map(a => a.id))
                setRowsSelectedSave(dataUserOpti?.data?.listaIdArtigosSelecionados)
            }

            if (arrayPosts.length > 0 && (continuar || (rowsSelectedSave.length == dataPlanoUsuario?.data?.quantidadeArtigos && gratuito)) && notExistPost < dataPlanoUsuario?.data?.quantidadeArtigos)
                savePostBaseOpti(dataUserOpti?.data?.usuarioWordpress, arrayPosts, setFinallySelection)
        }
    }, [dataUserOpti, rows])

    useEffect(() => { getUserOpti('obter_usuario_opti') }, [isSuccessSaveUserOpti])

    useEffect(() => {
        if (userOpti?.data) ManagerToken.loginAPI(`${URL}/token`)
    }, [userOpti?.data])

    useEffect(() => {
        if ((isLoadingSavePosts && isSuccess && !isError) || (selectedPostsList > 0 && isSuccess))
            setCountPostsSaved(prev => prev + 1)

        const reload = () => {
            if (finallySelection && isSuccess && !isError) {
                const domain = window.location.origin
                window.location.href = `${domain}/wp-admin/admin.php?page=optimarketing${redirecionarAnalytics ? "&analytics=true" : ""}`
            }
        }
        const timeoutId = setTimeout(reload, 5000)
        return () => clearTimeout(timeoutId)

    }, [finallySelection, isSuccess])

    useEffect(() => {
        savePostBaseOpti(dataUserOpti?.data?.usuarioWordpress, selectedPosts, setFinallySelection, isGratuito)
    }, [selectedPosts])

    const handleClick = async () => {
        setContinuar(true)
        setIsLoadingSavePosts(true)
        selectPosts(rowsSelected, rows, setSelectedPosts)
    }

    const toggleItem = (item) => {
        setRowsSelected((prevItems) => {
            if (prevItems.includes(item)) { return prevItems.filter(i => i !== item); }
            else { return [...prevItems, item]; }
        });
    };

    const selectAll = () => {
        if (rows.length == rowsSelected.length || (isGratuito && (rowsSelected.length == dataPlanoUsuario?.data?.quantidadeArtigos || rowsSelected.length + countPostsNotExist == dataPlanoUsuario?.data?.quantidadeArtigos))) setRowsSelected(rowsSelectedSave || [])
        else if (isGratuito) setRowsSelected(rows.map(item => item.id).slice(0, dataPlanoUsuario?.data?.quantidadeArtigos - countPostsNotExist))
        else (setRowsSelected(rows.map(item => item.id)))
    };

    conditional.isButtonDisable = rowsSelected == 0 || isLoadingSavePosts || selectedAllPostsNotExist

    return (
        <Modal botaoFechar={false} open={true} className="w-[80vw] h-[90vh] overflow-auto " titulo="Adicionar artigos">
            <div className='flex flex-col justify-between h-full'>
                <div>
                    <SearchPorPalavraChave metricasPaginadas={rows} setMetricasFiltradas={setFilteredRows} filtros={filtros} />
                    <table className="w-full table-auto flex flex-col divide-y divide-fundo-borda-grafico text-left mt-6">
                        <thead className="pb-6">
                            <tr className="flex w-full bg-neutras-grey-light rounded-lg py-2 px-6 gap-4">
                                <HeaderTable className="w-2/6" >
                                    <Checkbox className="mr-2"
                                        disabled={continuar}
                                        checked={rows.length == rowsSelected.length || (isGratuito && (rowsSelected.length == dataPlanoUsuario?.data?.quantidadeArtigos || rowsSelected.length + countPostsNotExist == dataPlanoUsuario?.data?.quantidadeArtigos)) } 
                                        onChange={selectAll} />
                                    TÍTULO DO ARTIGO
                                </HeaderTable>
                                <HeaderTable className="w-1/6">PALAVRA-CHAVE</HeaderTable>
                                <HeaderTable className="w-1/6">PUBLICAÇÃO</HeaderTable>
                                <HeaderTable className="w-1/6">CATEGORIA</HeaderTable>
                                <HeaderTable className="w-1/6">TAGS</HeaderTable>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-fundo-borda-grafico w-full">
                            {filteredRows.length > 0 ? filteredRows?.map(m =>
                                <tr key={m.id} className="flex w-full px-6 py-[0.625rem]">
                                    <ItemTable tamanho="2/6" className="pr-4">
                                        <Checkbox className="mr-2"
                                            disabled={
                                                continuar ||
                                                (isGratuito && rowsSelected.length == dataPlanoUsuario?.data?.quantidadeArtigos && rowsSelected?.filter(x => x == m?.id).length == 0) ||
                                                rowsSelectedSave?.filter(x => x == m?.id).length > 0
                                            }
                                            checked={rowsSelected?.filter(x => x == m?.id).length != 0}
                                            onChange={() => toggleItem(m?.id)} />
                                        <span className="truncate">{m?.title}</span>
                                    </ItemTable>
                                    <ItemTable tamanho="1/6" className="pr-4">
                                        {m?.keyword && m?.keyword != "sem palavra-chave" ?
                                            <div className="p-2 text-neutras-white bg-grey text-tbody2 rounded-full">
                                                {m?.keyword}
                                            </div>
                                            : <span className="text-error-main font-bold">Sem palavras-chave</span>}
                                    </ItemTable>
                                    <ItemTable tamanho="1/6" className="pr-4">
                                        {m?.postDateFormatted}
                                    </ItemTable>
                                    <ItemTable tamanho="1/6" className="pr-4">
                                        {m?.categories}
                                    </ItemTable>
                                    <ItemTable tamanho="1/6" className="pr-4">
                                        {m?.tags}
                                    </ItemTable>
                                </tr>) : CustomNoRowsOverlay}

                        </tbody>
                    </table>
                </div>
                <div className='mt-6'>
                    <div className="flex flex-row gap-4 justify-between">
                        <div>
                            {isError &&
                                <div>
                                    <CustomWarning alertType={alert.error} content={"Por favor, atualize a página e tente novamente"} />
                                </div>
                            }

                            {selectedPostsList > 0 && !isError && !selectedAllPostsNotExist && (continuar || rowsSelectedSave.length == dataPlanoUsuario?.data?.quantidadeArtigos) && countPostsNotExist < rowsSelectedSave.length &&
                                <div>
                                    <CustomWarning
                                        alertType={alert.info}
                                        content={"Alguns posts já foram escolhidos anteriormente, aguarde enquanto são registrados novamente."}
                                    />
                                </div>
                            }

                            {selectedAllPostsNotExist && !isError &&
                                <CustomWarning
                                    alertType={alert.error}
                                    content={"Parece que nenhum dos artigos selecionados anteriormente existe mais no Wordpress."}
                                />
                            }

                            {selectedPostsNotExist && !isError &&
                                <CustomWarning
                                    alertType={alert.warning}
                                    content={`Parece que alguns dos artigos selecionados anteriormente não existem mais no Wordpress. Mesmo excluidos a contabilização de artigos continuará a mesma. ${rowsSelectedSave.length}/${dataPlanoUsuario?.data?.quantidadeArtigos} artigos selecionados.`}
                                />
                            }


                            {rows == 0 &&
                                <CustomWarning
                                    alertType={alert.warning}
                                    content="Nosso plugin oferece monitoramento de artigos publicados e correção de artigos em criação. Para utilizar as funcionalidades de monitoramento de SERP, análise de SEO e legibilidade, é necessário ter pelo menos um post publicado em seu Blog.
                            Após ter pelo menos 1 artigo basta retornar a pagina do plugin e selecionar o artigo para ser monitorado em nosso Dashboard e começar a desfrutar de nossas funcionalidades. 
                            Obrigado por escolher a Opti."
                                    link="Criar artigo"
                                    linkClick={() => {
                                        const domain = window.location.origin
                                        window.location.href = `${domain}/wp-admin/edit.php`
                                    }}
                                />
                            }
                        </div>
                        <div className='flex gap-6 justify-end'>
                            <ButtonAdicionar
                                handleClick={handleClick}
                                disabled={conditional.isButtonDisable}
                                component='outlined'
                                className='flex font-bold'
                                countPostsSaved={countPostsSaved}
                                selectedPosts={selectedPosts}
                                condicaoMudarTexto={((isLoadingSavePosts && !isError) ||
                                    (selectedPostsList > 0 && !selectedAllPostsNotExist && !isError && continuar))}
                            >
                                Somente Adicionar Artigos Selecionados
                                <IoIosArrowForward component="padrao" className=" h-4 w-4" />
                            </ButtonAdicionar>

                            <ButtonAdicionar
                                esconderCarregar={true}
                                handleClick={() => {
                                    setRedirecionarAnalytics(true);
                                    handleClick();
                                }}
                                disabled={conditional.isButtonDisable}
                                component='filled'
                                className='font-bold'
                                countPostsSaved={countPostsSaved}
                                selectedPosts={selectedPosts}
                                condicaoMudarTexto={((isLoadingSavePosts && !isError) ||
                                    (selectedPostsList > 0 && !selectedAllPostsNotExist && !isError && continuar))}
                            >
                                Adicionar Artigos e Conectar Analytics
                            </ButtonAdicionar>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}